import React from 'react';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getPageData, getPageDataFooter} from '../../Actions/actions';
import footerLogo from '../../images/footer-logo.png';
// import { Link } from 'react-router-dom';

class Footer extends React.Component {
  constructor (props) {
    super (props);

    this.state = {
      userRole: localStorage.getItem ('roleName'),
      userTypeFooter: localStorage.getItem ('userTypeFooter'),
      userInfoR: {},
    };
  }

  componentDidMount () {
    const {userTypeFooter} = this.state;
    // console.log('userTypeFooter', userTypeFooter, userRole)
    if (userTypeFooter === 'Consumer') {
      this.props.getPageDataFooter (6);
    } else if (userTypeFooter === 'Business-User') {
      this.props.getPageDataFooter (7);
    } else {
      this.props.getPageDataFooter (7);
    }
  }

  componentDidUpdate () {
    const {userInfo} = this.props.data;
    const {userInfoR} = this.state;
    if (userInfo.roleName !== undefined) {
      if (userInfoR !== userInfo) {
        // console.log("userRole",nextProps.data.userInfo.roleName)
        if (userInfo.roleName === 'Consumer') {
          this.props.getPageDataFooter (6);
        } else if (userInfo.roleName === 'Business-User') {
          this.props.getPageDataFooter (7);
        } else {
          this.props.getPageDataFooter (7);
        }

        this.setState ({
          userInfoR: userInfo,
        });
      }
    }
  }

  render () {
    const {pageDetailsFooter} = this.props.data;
    // const { userRole } = this.state;
    return (
      <span>
        <footer className="page-footer colectively-footer ibmfont">
          <div className="container">
            <div className="row">
              <div className="col l3 m3 s12">
                <img
                  className="responsive-img footer-logo"
                  src={footerLogo}
                  alt=""
                />

              </div>
              <div className="col l9 m9 s12 ">
                <ul>
                  <li>
                    <a
                      className="grey-text text-lighten-3"
                      href="https://www.collectivelyapp.com/terms-and-conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a
                      className="grey-text text-lighten-3"
                      href="https://www.collectivelyapp.com/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      className="grey-text text-lighten-3"
                      href="http://support.collectivelyapp.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Help
                    </a>
                  </li>
                </ul>
                <p className="privacy-text">PRIVACY & LEGAL</p>

                {pageDetailsFooter !== undefined &&
                  pageDetailsFooter.body !== undefined &&
                  <p
                    dangerouslySetInnerHTML={{__html: pageDetailsFooter.body}}
                  />}
                {' '}
                {/* {(pageDetailsFooter !== undefined) ? (pageDetailsFooter.body !== undefined) ? ((<p dangerouslySetInnerHTML={{ __html: pageDetailsFooter.body }} />)) : (userRole === 'Consumer') ? (<p>Collectively is not a law firm and does not give legal advice. Collectively is not associated with the class administrator, the court, class counsel or any other official parties. You do not have to hire a third-party claims consultant and are entitled to file your claim on your own without incurring any fee</p>) : (userRole === 'Consumer') ? (
                  <p>
                    Collectively is not a law firm and does not give legal advice. Collectively is not associated with class administrators, the courts, class council or any other official parties associated with the settlements. For claimants qualifying and/or filing a claim to participate, please note that a third-party service is not required to participate in the monetary relief of settlements. No-cost assistance from the class administrator and class counsel is available. For more information, or to contact the class administrator or class counsel at no cost regarding all settlements, visit the official settlement websites.
                  </p>
                ) : (<p>Collectively is not a law firm and does not give legal advice. Collectively is not associated with the class administrator, the court, class counsel or any other official parties. You do not have to hire a third-party claims consultant and are entitled to file your claim on your own without incurring any fee. For The Payment Card Settlement Only: The new settlement was granted an initial approval by the court in January 2019. No claim forms are available and no claims-filing deadline exists, at this time. Class members are not required to sign up for a third-party service in order to participate in any monetary relief. No-cost assistance will be available from the Class Administrator and Class Counsel during the claims-filing period. Additional information is available at www.paymentcardsettlement.com, the Court-approved website for this case.</p>) : (<p>Collectively is not a law firm and does not give legal advice. Collectively is not associated with the class administrator, the court, class counsel or any other official parties. You do not have to hire a third-party claims consultant and are entitled to file your claim on your own without incurring any fee. For The Payment Card Settlement Only: The new settlement was granted an initial approval by the court in January 2019. No claim forms are available and no claims-filing deadline exists, at this time. Class members are not required to sign up for a third-party service in order to participate in any monetary relief. No-cost assistance will be available from the Class Administrator and Class Counsel during the claims-filing period. Additional information is available at www.paymentcardsettlement.com, the Court-approved website for this case.</p>)} */}
                <p>
                  Collectively ©
                  {' '}
                  {new Date ().getFullYear ()}
                  {' '}
                  All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </footer>
      </span>
    );
  }
}

const mapStateToProps = state => ({data: state.data});

const mapDispatchToProps = dispatch =>
  bindActionCreators ({getPageData, getPageDataFooter}, dispatch);

export default withRouter (
  connect (mapStateToProps, mapDispatchToProps) (Footer)
);
